import Navbar from "./Navbar";
import Hero from "./Hero";
import Stats from "./Stats";
import CoreValues from "./CoreValues";
import Contact from "./Contact";
import Footer from "./Footer";

import { Element } from "react-scroll";

export default function Home() {
  return (
    <>
      <Navbar />

      <Hero />

      <Stats />

      <CoreValues />

      <Element name="contact">
        <Contact />
      </Element>

      <Footer />
    </>
  );
}